import queryString from 'querystring';

import { Moment } from 'moment';

import * as Api from './api';

export class AccountApiClient {
  accountId: number;

  constructor(accountId: number) {
    this.accountId = accountId;
  }

  getAccountRoute = (route?: string) => `/account/${this.accountId}${route || ''}`;

  getBillingInfo = () => Api.get(`${this.getAccountRoute('/billing')}`);

  updateBasePlan = (basePlanUpdateRequest: BasePlanUpdateRequest) =>
    Api.post(`${this.getAccountRoute('/billing/base-plan')}`, {
      body: JSON.stringify({
        basePlanUpdateRequest,
      }),
    });

  updateAdSpend = (totalAdSpend: number, jobAdSpend: Array<JobAdSpend>) =>
    Api.post(`${this.getAccountRoute('/billing/job-spend')}`, {
      body: JSON.stringify({
        totalAdSpend,
        jobAdSpend,
      }),
    });

  updateBillingEmail = (newEmailAddress: string) =>
    Api.post(`${this.getAccountRoute('/billing/email')}`, {
      body: JSON.stringify({
        newEmailAddress,
      }),
    });

  setStatus = (status: AccountStatus, extraInfo: Record<string, any>) =>
    Api.post(`${this.getAccountRoute('/status')}`, {
      body: JSON.stringify({
        status,
        extraInfo,
      }),
    });

  updateTrialEndDate = (endDate: Moment) =>
    Api.post(`${this.getAccountRoute('/trial')}`, {
      body: JSON.stringify({
        trialEndDate: endDate,
      }),
    });

  loadActiveUserSubscriptions = () =>
    Api.get(`${this.getAccountRoute('/active-user-subscriptions')}`);

  addActiveUserSubscription = (subscribeToUser: string, isOneTime: boolean) =>
    Api.post(`${this.getAccountRoute('/active-user-subscriptions')}`, {
      body: JSON.stringify({
        subscribeToUser,
        isOneTime,
      }),
    });

  clearActiveUserSubscription = (username: string) =>
    Api.post(`${this.getAccountRoute('/active-user-subscriptions/unsubscribe')}`, {
      body: JSON.stringify({
        username,
      }),
    });

  static getBasePlans = () => Api.get('/account/base-plans');

  static search = (params: { status?: Array<AccountStatus> | AccountStatus; nameLike?: string }) =>
    Api.get(`/account/search?${queryString.stringify(params)}`);
}
